var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,style:(_vm.tabContainerStyle)},_vm._l((_vm.total),function(n){return _c('div',{key:n,class:(_vm.className + "__tab")})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }